/**
 * 환경별 파비콘 색상 설정
 *
 * 배포 호스트(hostname)를 기준으로 운영/스테이징/로컬을 판별한다. BE가 보고하는
 * env 값은 미인증(guest/401) 시 비신뢰라(프로덕션에서도 non-production으로 보임)
 * 호스트 판정을 단일 소스로 사용한다.
 */

import { detectRuntimeEnvFromBrowser } from "@/lib/config/runtimeEnv";

const ENV_COLORS: Record<string, string> = {
  local: "#9e9e9e",
  staging: "#00897b",
  live: "#000000",
};

function buildFaviconSvg(color: string): string {
  return [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">',
    `  <rect width="32" height="32" rx="6" fill="${color}"/>`,
    '  <text x="16" y="22" text-anchor="middle" fill="white" font-size="14" font-weight="bold">GGC</text>',
    "</svg>",
  ].join("\n");
}

export function updateFavicon() {
  const runtimeEnv = detectRuntimeEnvFromBrowser();
  const color = ENV_COLORS[runtimeEnv] ?? ENV_COLORS.staging;
  const svg = buildFaviconSvg(color);
  const blob = new Blob([svg], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);

  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/svg+xml";
  link.href = url;
}
